export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/facebookLogo.bee5e4ea.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};